import Axios from 'axios';
import { getHeaders } from '../../utills';
import AlertAction from '../Actions/AlertActions';
import CleanerTaskSummaryAction from '../Actions/CleanerTaskSummaryAction';
import CustomerActions from '../Actions/CustomerActions';
import GeneralAction from '../Actions/GeneralAction';
import Apis from '../Apis';
import CategoriesMiddleware from './CategoriesMiddleware';


class CleanerMiddleware {

  static cleanersCreate = (userData) => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading())
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append('first_name', userData?.Firstname);
          formdata.append('last_name', userData?.Lastname);
          formdata.append('email', userData?.Email);
          formdata.append('contact_no', userData?.ContactNumber);
          formdata.append('address', userData?.Address);
          formdata.append('lat', userData?.lat);
          formdata.append('lng', userData?.lng);
          formdata.append('category_id', userData?.SelectedCategoryID);
          formdata.append('working_start_time', userData?.StartTime);
          formdata.append('working_end_time', userData?.EndTime);
          formdata.append('break_time_in', userData?.BreakIn);
          formdata.append('break_time_out', userData?.BreakOut);
          const { data } = await Axios.post(
            Apis.cleanersCreate,
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data)
            dispatch(CategoriesMiddleware.getSubCategories(userData))
            dispatch(GeneralAction.HideLoading())
          } else {
            resolve(data)
            dispatch(GeneralAction.HideLoading())
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading())
        }
      });
    };
  }

  static cleanersEdit = (userData) => {
    console.log('first====>', userData)
    return dispatch => {
      dispatch(GeneralAction.ShowLoading())
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append('id', userData?.ID);
          formdata.append('first_name', userData?.Firstname);
          formdata.append('last_name', userData?.Lastname);
          formdata.append('contact_no', userData?.ContactNumber);
          formdata.append('address_id', userData?.AddressID);
          formdata.append('address', userData?.Address);
          formdata.append('lat', userData?.lat);
          formdata.append('lng', userData?.lng);
          formdata.append('category_id', userData?.SelectedCategoryID);
          formdata.append('working_start_time', userData?.StartTime);
          formdata.append('working_end_time', userData?.EndTime);
          formdata.append('break_time_in', userData?.BreakIn);
          formdata.append('break_time_out', userData?.BreakOut);
          const { data } = await Axios.post(
            Apis.cleanersUpdate,
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data)
            dispatch(CategoriesMiddleware.getSubCategories(userData))
            dispatch(GeneralAction.HideLoading())
          } else {
            resolve(data)
            dispatch(GeneralAction.HideLoading())
          }
        } catch (error) {
          reject(error);
          alert('Network Error');
          console.log(error);
          dispatch(GeneralAction.HideLoading())
        }
      });
    };
  }

  static getJobByCleanerid = userData => {
    return dispatch => {
      console.log(userData)
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (userData?.next_page_url == undefined) {
            dispatch(CleanerTaskSummaryAction.clearJobDetails());
          }

          formdata.append('cleaner_id', userData?.cleaner_id);
          formdata.append('status', userData?.status);
          const { data } = await Axios.post(
            Apis.getJobsByCleanerId(userData?.next_page_url),
            formdata,
            {
              headers: getHeaders()
            },
          );
          if (data?.success) {
            resolve(data);
            dispatch(CleanerTaskSummaryAction.getJobDetails(data?.data));
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static getCleanerDashboard = () => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading())
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await Axios.get(
            Apis.cleanerDashboard,
            {
              headers: getHeaders()
            }
          )
          if (data?.success) {
            resolve(data);
            dispatch(GeneralAction.HideLoading())
          } else {
            dispatch(GeneralAction.HideLoading())
          }
        }
        catch (error) {
          reject(error)
          console.log(error.message)
          dispatch(GeneralAction.HideLoading())
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
        }
      })
    }
  }


}

export default CleanerMiddleware;